<script context="module">
  function getCaretPosition(input) {
    // IE < 9 Support
    if (document.selection) {
      input.focus();
      const range = document.selection.createRange();
      const rangeLength = range.text.length;
      range.moveStart('character', -input.value.length);
      const start = range.text.length - rangeLength;
      return {start: start, end: start + rangeLength};
    }
    // IE >=9 and other browsers
    if (input.selectionStart || input.selectionStart === 0) {
      return {start: input.selectionStart, end: input.selectionEnd};
    }
    return {start: 0, end: 0};
  }

  function setCaretPosition(ctrl, {start, end}) {
    // IE >= 9 and other browsers
    if (ctrl.setSelectionRange) {
      ctrl.focus();
      ctrl.setSelectionRange(start, end);
    }
    // IE <script 9
    else if (ctrl.createTextRange) {
      const range = ctrl.createTextRange();
      range.collapse(true);
      range.moveEnd('character', end);
      range.moveStart('character', start);
      range.select();
    }
  }
</script>

<script>
  import {onMount, createEventDispatcher, getContext} from 'svelte';

  let className = '';

  export {className as class};
  export let len = null;
  export let value = '';
  export let disabled = false;
  export let placeholder = '';
  export let clearable = false;

  const dispatch = createEventDispatcher();
  const field$ = getContext('field');

  let input = null;
  let oldText = '';
  let oldPosition = null;

  $: !field$ && setInputValue(input, value);

  onMount(() => {
    if (!field$) {
      return;
    }
    if ($$props.hasOwnProperty('value')) {
      console.warn('Input Value binding is invalid');
    }
    const initialValue = $field$;
    if (initialValue !== value) {
      value = initialValue;
      oldText = initialValue;
      setInputValue(input, initialValue);
    }
  });

  function updateField(value) {
    field$ && field$.set(value);
  }

  function handleInput(e) {
    const input = e.target;
    const text = input.value;
    if (len && text.length > len) {
      rollback(input);
      return;
    }
    value = text;
    oldText = text;
    updateField(text);
    dispatch('change', {value: text});
  }

  function rollback(input) {
    setInputValue(input, oldText);
    oldPosition && setCaretPosition(input, oldPosition);
    oldPosition = null;
  }

  function setInputValue(input, newText) {
    if (input && input.value !== newText) {
      input.value = newText;
    }
  }

  function handleClearClick() {
    value = '';
    oldText = '';
    updateField('');
    dispatch('change', {value: ''});
  }

  function handleKeyDown(e) {
    oldPosition = getCaretPosition(e.target);
    dispatch('keydown', e);
  }
</script>

<style>
  input {
    margin: 0;
    box-sizing: border-box;
    border: none;
    padding: 14px 16px;
    width: 100%;
    line-height: inherit;
    font-size: inherit;
    background: transparent;
    outline: none;
  }
  .pm-input {
    border: 1px solid var(--BD);
  }
  .close-icon {
    color: var(--T5);
  }
  input:read-only {
    cursor: not-allowed;
  }
  input::placeholder {
    color: var(--T6);
  }
</style>

<div class="pm-input df aic br4">
  <slot name="prefix" />
  <input class="fw5 T2 {className}" class:disabled readonly={disabled} {placeholder} type="text" bind:this={input} on:keydown={handleKeyDown} on:focus on:blur on:input={handleInput} />
  {#if clearable && value}
    <i class="close-icon iconfont mr16 f16 cp" on:click={handleClearClick}>&#xe6cd;</i>
  {/if}
  <slot name="suffix" />
</div>
